module.exports = __webpack_public_path__ + "img/liteapp.ec160f7f.jpg";